<template>
  <div class="slot-filters-by-etc">
    <div class="app-input-row">
      <div class="app-input-group">
        <label for="byLocation">Filter by location</label>
        <select class="app-select" id="byLocation" ref="byLocation" v-model="myLocation"
                @change="filter">
          <option v-if="uniqueLocations.length > 1" value="all">All available</option>
          <option v-for="location in uniqueLocations" :key="location" :value="location">
            {{ location }}
          </option>
        </select>
      </div>
      <div class="app-input-group">
        <label for="byTime">Filter by time of day</label>
        <select class="app-select" id="byTime" ref="byTime" v-model="myTime"
                @change="filter">
          <option v-if="uniqueTimes.length > 1" value="all">All available</option>
          <option v-for="time in uniqueTimes" :key="time" :value="time">
            {{ formatTimeOfDay(time) }}
          </option>
        </select>
      </div>
      <div class="app-input-group">
        <label for="byWeek">Filter by week</label>
        <select class="app-select" id="byWeek" ref="byWeek" v-model="myWeek"
                @change="filter({ weekly: true })">
          <option v-for="(week, i) in resSlottedWeeks" :key="`week-${i}`" :value="i">
            {{ formatMonthDay(week.from) }} - {{ formatMonthDay(week.to) }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import _ from "underscore";

import { SLOTS_STORE_DATA } from '@/store/_commons';

import { formatTimeOfDay, formatMonthDay } from '../../../utils/globalFilters';
const store = useStore();

// Define props using the `defineProps` compiler macro
const props = defineProps({
  weekIndex: {
    type: Number,
    required: true,
  },
});

// Define emits using the `defineEmits` compiler macro
const emit = defineEmits(['doFilters']);

// Reactive state, replacing `data()`
const uniqueLocations = ref([]);
const uniqueTimes = ref([]);
const myLocation = ref('');
const myTime = ref('');
const myWeek = ref(0);

// Mapped state and getters, replacing `mapState` and `mapGetters`
const slotsStates = computed(() => store.getters[SLOTS_STORE_DATA]);
const availableSlotsByVisitType = computed(() => store.state.user.availableSlotsByVisitType);
const resSlottedWeeks = computed(() => store.state.user.resSlottedWeeks);

// Lifecycle hook, replacing `created()`
onMounted(() => {
  getUniqueLocations();
  getUniqueTimes();
  myWeek.value = props.weekIndex;
});

// Watchers, replacing `watch` option
watch(availableSlotsByVisitType, () => {
  getUniqueLocations();
  getUniqueTimes();
});

watch(uniqueLocations, () => {
  if (uniqueLocations.value.length === 1) {
    myLocation.value = uniqueLocations.value[0];
  } else {
    myLocation.value = slotsStates.value.defaultSelectOption;
  }
});

watch(uniqueTimes, () => {
  if (uniqueTimes.value.length === 1) {
    myTime.value = uniqueTimes.value[0];
  } else {
    myTime.value = slotsStates.value.defaultSelectOption;
  }
});

watch(() => props.weekIndex, (newVal) => {
  myWeek.value = newVal;
});

// Methods, replacing `methods` option
const filter = (data) => {
  emit('doFilters', {
    location: myLocation.value,
    time: myTime.value,
    week: myWeek.value,
    byXDays: data?.weekly ? !data.weekly : undefined,
  });
};

const getUniqueProperty = (prop) => {
  return _.sortBy(_.uniq(_.map(availableSlotsByVisitType.value, item => item[prop])));
};

const getUniqueLocations = () => {
  const list = getUniqueProperty('location');
  uniqueLocations.value = _.filter(list, item => item.length > 0);
};

const getUniqueTimes = () => {
  const list = getUniqueProperty('startTime');
  uniqueTimes.value = _.uniq(_.map(list, item => {
    const wd = new Date(`2021-03-31T${item}`);
    const str = wd.toLocaleTimeString(undefined, { hour12: true });
    return str.substring(str.length - 2);
  }));
};
</script>

<style scoped lang="scss">
.slot-filters-by-etc {
  flex-grow: 1;
  .app-input-group {
    // overwrite global app-input-group
    margin-bottom: 0.5em;
  }
}
</style>
